import React, { Component } from 'react';
import everybodyIn from '../../img/Cubs_News_Bullseye_Final.jpg';
import Moment from 'moment';

function PlainTextToHtml({ text }) {
  if (!text) return null;

  let html = String(text).trim();

  // If hero_image/body is just a bare URL, wrap it as an <img>.
  // Covers both ImageServer URLs and other URLs.
  const isBareUrl =
    /^https?:\/\/\S+$/i.test(html) &&
    !html.includes('<') &&
    !html.includes('>');

  if (isBareUrl) {
    html = `<img src="${html}" width="100%" height="auto" />`;
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  }

  // Convert existing <img ... src="..."> tags into clean <img src="..."/>
  const imgTagRegex = /<img.*?src="(.*?)".*?\/?>/gi;
  const matches = [...html.matchAll(imgTagRegex)];
  matches.forEach((match) => {
    const imgTag = `<img src="${match[1]}" width="100%" height="auto" />`;
    html = html.replace(match[0], imgTag);
  });

  // Convert any bare Salesforce ImageServer URL occurrences inside HTML to <img>
  const imageServerRegex =
    /(https:\/\/chicagocubs\.(my\.salesforce|file\.force)\.com\/servlet\/servlet\.ImageServer\?[^"\s<]+)(\s|$)/gi;
  html = html.replace(imageServerRegex, '<img src="$1" width="100%" height="auto" />$3');

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}

class newsTemplate extends Component {
  constructor(props) {
    super(props);
    this.listRef = React.createRef();
  }

  componentDidMount() {
    if (window.location.hash) {
      const element = document.getElementById(window.location.hash.replace('#', ''));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView();
        }, 600);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const prevNews = this.getNews(prevProps);
    const nextNews = this.getNews(this.props);

    const prevStories = Array.isArray(prevNews?.stories) ? prevNews.stories : [];
    const nextStories = Array.isArray(nextNews?.stories) ? nextNews.stories : [];

    if (prevStories !== nextStories) {
      this.listRef = React.createRef();
    }
  }

  getNews(props) {
    // Backward compatible:
    // - old path: props.news is an array => use [0]
    // - new path: props.news is an object => use directly
    if (Array.isArray(props?.news)) return props.news[0] || null;
    if (props?.news && typeof props.news === 'object') return props.news;
    return null;
  }

  render() {
    const news = this.getNews(this.props);

    if (!news) {
      return (
        <section className="section">
          <div className="section-content row news-detail-intro">
            <div className="col md-12">
              <h1><b>Article not found</b></h1>
            </div>
          </div>
        </section>
      );
    }

    const date = news.publish_date ? Moment.utc(news.publish_date).format('MMMM DD, YYYY') : '';

    return (
      <section className="section">
        <div className="section-content row news-detail-intro">
          <div className="col md-12">
            <h1> <b>{news.email_header}</b></h1>
          </div>

          <div>
            {/* If hero_image exists, render it; if not, use your fallback */}
            {news.hero_image ? (
              <PlainTextToHtml text={news.hero_image} />
            ) : (
              <img src={everybodyIn} alt="" width="100%" height="auto" />
            )}
          </div>

          <div className="col md-12">
            <br />
            <div>
              {date ? <h1><b>{date}</b></h1> : null}
            </div>
            <br />
            <h1><b>In the News This Week...</b></h1>

            <ul>
              <ul ref={this.listRef}>
                {(news.stories || []).map((link, index) => (
                  <li key={index}>
                    <a href={`#link-${index}`}>{link.subject}</a>
                  </li>
                ))}
              </ul>
            </ul>

            <hr />

            <ul>
              <ul>
                {(news.stories || []).map((link, index) => (
                  <li key={index} id={`link-${index}`}>
                    <h3><b>{link.subject}</b></h3>
                    <PlainTextToHtml text={link.body} />
                    <p />
                  </li>
                ))}
              </ul>
            </ul>
          </div>

          <a href="/cubs-news">
            <div> ALL NEWS </div>
          </a>
        </div>
      </section>
    );
  }
}

export default newsTemplate;